import { Button, Col, Row, Tooltip } from "antd";
import { ExpiringContracts, LatestContracts } from "./Widgets";
import styles from "@styles/variables.module.scss";
import { useCallback, useEffect, useRef, useState } from "react";
import { useNotification } from "~/Hooks/useNotification";
import { get } from "@services/api.service";
import { get as _get } from "lodash";
import { useHasAccess } from "@hooks/useHasAccess";
import { ModuleType, subsidiaries } from "@utils/StringConstants";
import { useAuth } from "@hooks/useAuth";
import { PieChart, SkeletonPieChart, WrapperCard } from "~/Components";
import { hasKeyString, scrollToElement } from "@utils/CommonUtils";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Icon } from "@iconify/react";
import { FilterDropDown } from "@components/FilterDropDown/FilterDropDown";
import { Subsidiary } from "../../Subsidiaries/Subsidiaries";
import { useQuery } from "~/Hooks/useQuery";
import ExcelJS from "exceljs";
import html2canvas from "html2canvas";

export const Dashboard = () => {
  const colCommonStyles = {
    marginBottom: styles.whitespace2,
  };
  const overallChartRef = useRef<HTMLDivElement | null>(null);
  const watcherChartRef = useRef<HTMLDivElement | null>(null);
  const approverChartRef = useRef<HTMLDivElement | null>(null);
  const [searchParams, setSearchParams] = useSearchParams();
  const paramsObj = Object.fromEntries(searchParams.entries());
  const [dashboardData, setDashboardData] = useState<any>({});
  const [creatorDate, setCreatorDate] = useState<any>({ from: "", to: "" });
  const [creatorSubsidiary, setCreatorSubsidiary] = useState<any>("");
  const [creatorDivision, setCreatorDivision] = useState<any>("");
  const [creatorAmountData, setCreatorAmountData] = useState([0, 10000000]);
  const [creatorBudgetValue, setCreatorBudgetValue] = useState<any>("");
  const [creatorPaperValue, setCreatorPaperValue] = useState<any>("");
  const navigate = useNavigate();

  const [watcherDate, setWatcherDate] = useState<any>({ from: "", to: "" });
  const [watcherSubsidiary, setWatcherSubsidiary] = useState<any>("");
  const [watcherDivision, setWatcherDivision] = useState<any>("");
  const [watcherAmountData, setWatcherAmountData] = useState([0, 10000000]);
  const [watcherBudgetValue, setWatcherBudgetValue] = useState<any>("");
  const [watcherPaperValue, setWatcherPaperValue] = useState<any>("");

  const [approverDate, setApproverDate] = useState<any>({ from: "", to: "" });
  const [approverSubsidiary, setApproverSubsidiary] = useState<any>("");
  const [approverDivision, setApproverDivision] = useState<any>("");
  const [approverBudgetValue, setApproverBudgetValue] = useState<any>("");
  const [approverPaperValue, setApproverPaperValue] = useState<any>("");
  const [approverAmountData, setApproverAmountData] = useState([0, 10000000]);

  const [onBoardingList, setOnboardingList] = useState<any>();
  const [creatorMetric, setCreatorMetric] = useState<any>();
  const [approverMetric, setApproverMetric] = useState<any>();
  const [watcherMetric, setWatcherMetric] = useState<any>();

  const { openToast } = useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuth();
  const { hasRole } = useHasAccess();
  const query = useQuery();

  const [page, setpage] = useState<number>(parseInt(query.get("onboardedListPage") ?? ""));

  const [pageStart, setPageStart] = useState<any>(parseInt(query.get("onboardedListPage") || "0") || 0);
  const [recordsPerPage, setRecordsPerPage] = useState<number>(5);
  const [totalPage, setTotalPage] = useState<number>(0);
  const [isMobile, setIsMobile] = useState(false);

  const [onboardListPage, setOnboradListPage] = useState(3);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handlePageChange = (newPage: any) => {
    const startIndex = newPage - 1;
    setpage(newPage - 1);
    setPageStart(startIndex);
  };

  const subsidiary = searchParams.get("subsidiary");
  const division: any = searchParams.get("division") ?? "";
  const budget: any = searchParams.get("budget");
  const paper = searchParams.get("paper");
  const startDate = searchParams.get("startDate");
  const endDate = searchParams.get("endDate");
  const startAmount = searchParams.get("startAmount");
  const endAmount = searchParams.get("endAmount");
  useEffect(() => {
    setCreatorDate({ from: startDate, to: endDate });
  }, [startDate, endDate]);
  const getCreatorMetrics = () => {
    setIsLoading(true);
    get(
      `/v1/spa/dashboard/creator/view?subsidiary=${subsidiary ?? ""}&division=${encodeURIComponent(division) ?? ""}&startAmount=${
        startAmount ?? ""
      }&endAmount=${endAmount ?? ""}&startDate=${creatorDate.from ?? ""}&endDate=${
        creatorDate?.to ?? ""
      }&budget=${encodeURIComponent(budget ?? "")}&awardAndStrategyPaper=${paper ?? ""}`
    )
      .then((res: any) => {
        setIsLoading(false);
        setCreatorMetric(res.response.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };
  const getApproverMetrics = () => {
    setIsLoading(true);
    get(
      `v1/spa/dashboard/approver/view?subsidiary=${subsidiary ?? ""}&division=${encodeURIComponent(division) ?? ""}&startAmount=${
        startAmount ?? ""
      }&endAmount=${endAmount ?? ""}&startDate=${creatorDate.from ?? ""}&endDate=${
        creatorDate?.to ?? ""
      }&budget=${encodeURIComponent(budget ?? "")}&awardAndStrategyPaper=${paper ?? ""}`
    )
      .then((res: any) => {
        setIsLoading(false);
        setApproverMetric(res.response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getWatcherMetrics = () => {
    setIsLoading(true);
    get(
      `v1/spa/dashboard/watcher/view?subsidiary=${subsidiary ?? ""}&division=${encodeURIComponent(division) ?? ""}&startAmount=${
        startAmount ?? ""
      }&endAmount=${endAmount ?? ""}&startDate=${creatorDate?.from ?? ""}&endDate=${
        creatorDate?.to ?? ""
      }&budget=${encodeURIComponent(budget ?? "")}&awardAndStrategyPaper=${paper ?? ""}`
    )
      .then((res: any) => {
        setIsLoading(false);
        setWatcherMetric(res.response.data);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

  const getCompletedList = () => {
    setIsLoading(true);
    get(`v1/spa/dashboard/onboarded-list?page=${pageStart}&size=${recordsPerPage}`)
      .then((res: any) => {
        if (res && res.response) {
          setTotalPage(res.response.data.totalCount || 0);
          setOnboardingList(res.response.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  };

const handleOverAllView = async () => {
  try {
    console.log("=== [OverAllView] Export START ===");
    console.log("[OverAllView] overallChartRef.current:", overallChartRef.current);
    console.log("[OverAllView] overallChartRef.current tagName:", overallChartRef.current?.tagName);
    console.log("[OverAllView] overallChartRef.current offsetWidth x offsetHeight:", overallChartRef.current?.offsetWidth, "x", overallChartRef.current?.offsetHeight);
    console.log("[OverAllView] allCreatorGraph:", allCreatorGraph);
    console.log("[OverAllView] allCreatorGraph length:", allCreatorGraph?.length);

    if (!overallChartRef.current || !allCreatorGraph?.length) {
      console.warn("[OverAllView] GUARD FAILED — ref available:", !!overallChartRef.current, "| data length:", allCreatorGraph?.length ?? 0);
      return;
    }

    console.log("[OverAllView] Guard passed. Checking element visibility...");
    const el = overallChartRef.current;
    const rect = el.getBoundingClientRect();
    console.log("[OverAllView] getBoundingClientRect:", JSON.stringify(rect));
    console.log("[OverAllView] Element in DOM:", document.body.contains(el));
    console.log("[OverAllView] Element computed display:", window.getComputedStyle(el).display);
    console.log("[OverAllView] Element computed visibility:", window.getComputedStyle(el).visibility);
    console.log("[OverAllView] Element computed opacity:", window.getComputedStyle(el).opacity);

    console.log("[OverAllView] Calling html2canvas...");
    let canvas: HTMLCanvasElement;
    try {
      canvas = await html2canvas(el, {
        scale: 2,
        backgroundColor: "#ffffff",
        logging: true,
      });
      console.log("[OverAllView] html2canvas SUCCESS. Canvas width:", canvas.width, "| height:", canvas.height);
    } catch (canvasErr) {
      console.error("[OverAllView] html2canvas THREW ERROR:", canvasErr);
      throw canvasErr;
    }

    console.log("[OverAllView] Converting canvas to base64...");
    const imageBase64 = canvas.toDataURL("image/png");
    console.log("[OverAllView] imageBase64 length:", imageBase64.length);
    console.log("[OverAllView] imageBase64 prefix (first 50 chars):", imageBase64.substring(0, 50));
    if (imageBase64 === "data:,") {
      console.error("[OverAllView] imageBase64 is EMPTY — canvas was blank. Likely a tainted/cross-origin canvas issue.");
    }

    console.log("[OverAllView] Creating ExcelJS Workbook...");
    const workbook = new ExcelJS.Workbook();
    console.log("[OverAllView] Adding worksheet 'Overall View'...");
    const worksheet = workbook.addWorksheet("Overall View");

    console.log("[OverAllView] Merging header cells A1:D1...");
    worksheet.mergeCells("A1:D1");
    worksheet.getCell("A1").value = "Overall View - Pie Chart";
    worksheet.getCell("A1").font = { bold: true, size: 14 };
    console.log("[OverAllView] Header cell set.");

    console.log("[OverAllView] Adding image to workbook...");
    let imageId: number;
    try {
      imageId = workbook.addImage({ base64: imageBase64, extension: "png" });
      console.log("[OverAllView] Image added to workbook. imageId:", imageId);
    } catch (imgErr) {
      console.error("[OverAllView] workbook.addImage THREW ERROR:", imgErr);
      throw imgErr;
    }

    console.log("[OverAllView] Placing image on worksheet at tl:{col:0,row:2} ext:{width:1000,height:300}...");
    worksheet.addImage(imageId, {
      tl: { col: 0, row: 2 },
      ext: { width: 1000, height: 300 },
    });
    console.log("[OverAllView] Image placed on worksheet.");

    const startRow = 22;
    console.log("[OverAllView] Writing column headers at row:", startRow);
    worksheet.getRow(startRow).values = ["Category", "Count"];
    worksheet.getRow(startRow).font = { bold: true };

    console.log("[OverAllView] Writing", allCreatorGraph.length, "data rows starting at row:", startRow + 1);
    allCreatorGraph.forEach((item: any, index: any) => {
      console.log(`[OverAllView] Row ${startRow + index + 1} — category: "${item?.category}" | value: "${item?.value}"`);
      worksheet.getRow(startRow + index + 1).values = [item?.category, item?.value];
    });

    console.log("[OverAllView] Setting column widths...");
    worksheet.columns = [{ width: 30 }, { width: 15 }];

    console.log("[OverAllView] Writing workbook to buffer...");
let buffer: ArrayBuffer;
try {
  buffer = await workbook.xlsx.writeBuffer() as unknown as ArrayBuffer;
  console.log("[OverAllView] Buffer written. Byte length:", buffer.byteLength);
    } catch (bufErr) {
      console.error("[OverAllView] workbook.xlsx.writeBuffer THREW ERROR:", bufErr);
      throw bufErr;
    }

    console.log("[OverAllView] Creating Blob...");
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    console.log("[OverAllView] Blob size:", blob.size, "| type:", blob.type);

    console.log("[OverAllView] Creating object URL and triggering download...");
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Overall_View_PieChart_With_Data.xlsx";
    console.log("[OverAllView] Object URL created:", link.href.substring(0, 60));
    link.click();
    console.log("[OverAllView] link.click() called.");

    URL.revokeObjectURL(link.href);
    console.log("[OverAllView] Object URL revoked.");
    console.log("=== [OverAllView] Export COMPLETE ===");
  } catch (error) {
    console.error("=== [OverAllView] Export FAILED ===");
    console.error("[OverAllView] Error name:", (error as Error)?.name);
    console.error("[OverAllView] Error message:", (error as Error)?.message);
    console.error("[OverAllView] Error stack:", (error as Error)?.stack);
    console.error("[OverAllView] Full error object:", error);
  }
};

const handleWatcherView = async () => {
  try {
    console.log("=== [WatcherView] Export START ===");
    console.log("[WatcherView] watcherChartRef.current:", watcherChartRef.current);
    console.log("[WatcherView] watcherChartRef.current tagName:", watcherChartRef.current?.tagName);
    console.log("[WatcherView] watcherChartRef.current offsetWidth x offsetHeight:", watcherChartRef.current?.offsetWidth, "x", watcherChartRef.current?.offsetHeight);
    console.log("[WatcherView] watchersGraph:", watchersGraph);
    console.log("[WatcherView] watchersGraph length:", watchersGraph?.length);

    if (!watcherChartRef.current || !watchersGraph?.length) {
      console.warn("[WatcherView] GUARD FAILED — ref available:", !!watcherChartRef.current, "| data length:", watchersGraph?.length ?? 0);
      return;
    }

    console.log("[WatcherView] Guard passed. Checking element visibility...");
    const el = watcherChartRef.current;
    const rect = el.getBoundingClientRect();
    console.log("[WatcherView] getBoundingClientRect:", JSON.stringify(rect));
    console.log("[WatcherView] Element in DOM:", document.body.contains(el));
    console.log("[WatcherView] Element computed display:", window.getComputedStyle(el).display);
    console.log("[WatcherView] Element computed visibility:", window.getComputedStyle(el).visibility);
    console.log("[WatcherView] Element computed opacity:", window.getComputedStyle(el).opacity);

    console.log("[WatcherView] Calling html2canvas...");
    let canvas: HTMLCanvasElement;
    try {
      canvas = await html2canvas(el, {
        scale: 2,
        backgroundColor: "#ffffff",
        logging: true,
      });
      console.log("[WatcherView] html2canvas SUCCESS. Canvas width:", canvas.width, "| height:", canvas.height);
    } catch (canvasErr) {
      console.error("[WatcherView] html2canvas THREW ERROR:", canvasErr);
      throw canvasErr;
    }

    console.log("[WatcherView] Converting canvas to base64...");
    const imageBase64 = canvas.toDataURL("image/png");
    console.log("[WatcherView] imageBase64 length:", imageBase64.length);
    console.log("[WatcherView] imageBase64 prefix (first 50 chars):", imageBase64.substring(0, 50));
    if (imageBase64 === "data:,") {
      console.error("[WatcherView] imageBase64 is EMPTY — canvas was blank. Likely a tainted/cross-origin canvas issue.");
    }

    console.log("[WatcherView] Creating ExcelJS Workbook...");
    const workbook = new ExcelJS.Workbook();
    console.log("[WatcherView] Adding worksheet 'Watcher View'...");
    const worksheet = workbook.addWorksheet("Watcher View");

    console.log("[WatcherView] Merging header cells A1:D1...");
    worksheet.mergeCells("A1:D1");
    worksheet.getCell("A1").value = "Watcher - Pie Chart";
    worksheet.getCell("A1").font = { bold: true, size: 14 };
    console.log("[WatcherView] Header cell set.");

    console.log("[WatcherView] Adding image to workbook...");
    let imageId: number;
    try {
      imageId = workbook.addImage({ base64: imageBase64, extension: "png" });
      console.log("[WatcherView] Image added to workbook. imageId:", imageId);
    } catch (imgErr) {
      console.error("[WatcherView] workbook.addImage THREW ERROR:", imgErr);
      throw imgErr;
    }

    console.log("[WatcherView] Placing image on worksheet at tl:{col:0,row:2} ext:{width:1000,height:300}...");
    worksheet.addImage(imageId, {
      tl: { col: 0, row: 2 },
      ext: { width: 1000, height: 300 },
    });
    console.log("[WatcherView] Image placed on worksheet.");

    const startRow = 22;
    console.log("[WatcherView] Writing column headers at row:", startRow);
    worksheet.getRow(startRow).values = ["Category", "Count"];
    worksheet.getRow(startRow).font = { bold: true };

    console.log("[WatcherView] Writing", watchersGraph.length, "data rows starting at row:", startRow + 1);
    watchersGraph.forEach((item: any, index: any) => {
      console.log(`[WatcherView] Row ${startRow + index + 1} — category: "${item?.category}" | value: "${item?.value}"`);
      worksheet.getRow(startRow + index + 1).values = [item?.category, item?.value];
    });

    console.log("[WatcherView] Setting column widths...");
    worksheet.columns = [{ width: 30 }, { width: 15 }];

    console.log("[WatcherView] Writing workbook to buffer...");
let buffer: ArrayBuffer;
try {
  buffer = await workbook.xlsx.writeBuffer() as unknown as ArrayBuffer;
  console.log("[OverAllView] Buffer written. Byte length:", buffer.byteLength);
    } catch (bufErr) {
      console.error("[WatcherView] workbook.xlsx.writeBuffer THREW ERROR:", bufErr);
      throw bufErr;
    }

    console.log("[WatcherView] Creating Blob...");
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    console.log("[WatcherView] Blob size:", blob.size, "| type:", blob.type);

    console.log("[WatcherView] Creating object URL and triggering download...");
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Watcher_View_PieChart_With_Data.xlsx";
    console.log("[WatcherView] Object URL created:", link.href.substring(0, 60));
    link.click();
    console.log("[WatcherView] link.click() called.");

    URL.revokeObjectURL(link.href);
    console.log("[WatcherView] Object URL revoked.");
    console.log("=== [WatcherView] Export COMPLETE ===");
  } catch (error) {
    console.error("=== [WatcherView] Export FAILED ===");
    console.error("[WatcherView] Error name:", (error as Error)?.name);
    console.error("[WatcherView] Error message:", (error as Error)?.message);
    console.error("[WatcherView] Error stack:", (error as Error)?.stack);
    console.error("[WatcherView] Full error object:", error);
  }
};

const handleApproverView = async () => {
  try {
    console.log("=== [ApproverView] Export START ===");
    console.log("[ApproverView] approverChartRef.current:", approverChartRef.current);
    console.log("[ApproverView] approverChartRef.current tagName:", approverChartRef.current?.tagName);
    console.log("[ApproverView] approverChartRef.current offsetWidth x offsetHeight:", approverChartRef.current?.offsetWidth, "x", approverChartRef.current?.offsetHeight);
    console.log("[ApproverView] allReviewerGraph:", allReviewerGraph);
    console.log("[ApproverView] allReviewerGraph length:", allReviewerGraph?.length);

    if (!approverChartRef.current || !allReviewerGraph?.length) {
      console.warn("[ApproverView] GUARD FAILED — ref available:", !!approverChartRef.current, "| data length:", allReviewerGraph?.length ?? 0);
      return;
    }

    console.log("[ApproverView] Guard passed. Checking element visibility...");
    const el = approverChartRef.current;
    const rect = el.getBoundingClientRect();
    console.log("[ApproverView] getBoundingClientRect:", JSON.stringify(rect));
    console.log("[ApproverView] Element in DOM:", document.body.contains(el));
    console.log("[ApproverView] Element computed display:", window.getComputedStyle(el).display);
    console.log("[ApproverView] Element computed visibility:", window.getComputedStyle(el).visibility);
    console.log("[ApproverView] Element computed opacity:", window.getComputedStyle(el).opacity);

    console.log("[ApproverView] Calling html2canvas...");
    let canvas: HTMLCanvasElement;
    try {
      canvas = await html2canvas(el, {
        scale: 2,
        backgroundColor: "#ffffff",
        logging: true,
      });
      console.log("[ApproverView] html2canvas SUCCESS. Canvas width:", canvas.width, "| height:", canvas.height);
    } catch (canvasErr) {
      console.error("[ApproverView] html2canvas THREW ERROR:", canvasErr);
      throw canvasErr;
    }

    console.log("[ApproverView] Converting canvas to base64...");
    const imageBase64 = canvas.toDataURL("image/png");
    console.log("[ApproverView] imageBase64 length:", imageBase64.length);
    console.log("[ApproverView] imageBase64 prefix (first 50 chars):", imageBase64.substring(0, 50));
    if (imageBase64 === "data:,") {
      console.error("[ApproverView] imageBase64 is EMPTY — canvas was blank. Likely a tainted/cross-origin canvas issue.");
    }

    console.log("[ApproverView] Creating ExcelJS Workbook...");
    const workbook = new ExcelJS.Workbook();
    console.log("[ApproverView] Adding worksheet 'Approver View'...");
    const worksheet = workbook.addWorksheet("Approver View");

    console.log("[ApproverView] Merging header cells A1:D1...");
    worksheet.mergeCells("A1:D1");
    worksheet.getCell("A1").value = "Approver View - Pie Chart";
    worksheet.getCell("A1").font = { bold: true, size: 14 };
    console.log("[ApproverView] Header cell set.");

    console.log("[ApproverView] Adding image to workbook...");
    let imageId: number;
    try {
      imageId = workbook.addImage({ base64: imageBase64, extension: "png" });
      console.log("[ApproverView] Image added to workbook. imageId:", imageId);
    } catch (imgErr) {
      console.error("[ApproverView] workbook.addImage THREW ERROR:", imgErr);
      throw imgErr;
    }

    console.log("[ApproverView] Placing image on worksheet at tl:{col:0,row:2} ext:{width:1000,height:300}...");
    worksheet.addImage(imageId, {
      tl: { col: 0, row: 2 },
      ext: { width: 1000, height: 300 },
    });
    console.log("[ApproverView] Image placed on worksheet.");

    const startRow = 22;
    console.log("[ApproverView] Writing column headers at row:", startRow);
    worksheet.getRow(startRow).values = ["Category", "Count"];
    worksheet.getRow(startRow).font = { bold: true };

    console.log("[ApproverView] Writing", allReviewerGraph.length, "data rows starting at row:", startRow + 1);
    allReviewerGraph.forEach((item: any, index: any) => {
      console.log(`[ApproverView] Row ${startRow + index + 1} — category: "${item?.category}" | value: "${item?.value}"`);
      worksheet.getRow(startRow + index + 1).values = [item?.category, item?.value];
    });

    console.log("[ApproverView] Setting column widths...");
    worksheet.columns = [{ width: 30 }, { width: 15 }];

    console.log("[ApproverView] Writing workbook to buffer...");
let buffer: ArrayBuffer;
try {
  buffer = await workbook.xlsx.writeBuffer() as unknown as ArrayBuffer;
  console.log("[OverAllView] Buffer written. Byte length:", buffer.byteLength);
    } catch (bufErr) {
      console.error("[ApproverView] workbook.xlsx.writeBuffer THREW ERROR:", bufErr);
      throw bufErr;
    }

    console.log("[ApproverView] Creating Blob...");
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    console.log("[ApproverView] Blob size:", blob.size, "| type:", blob.type);

    console.log("[ApproverView] Creating object URL and triggering download...");
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = "Approver_View_PieChart_With_Data.xlsx";
    console.log("[ApproverView] Object URL created:", link.href.substring(0, 60));
    link.click();
    console.log("[ApproverView] link.click() called.");

    URL.revokeObjectURL(link.href);
    console.log("[ApproverView] Object URL revoked.");
    console.log("=== [ApproverView] Export COMPLETE ===");
  } catch (error) {
    console.error("=== [ApproverView] Export FAILED ===");
    console.error("[ApproverView] Error name:", (error as Error)?.name);
    console.error("[ApproverView] Error message:", (error as Error)?.message);
    console.error("[ApproverView] Error stack:", (error as Error)?.stack);
    console.error("[ApproverView] Full error object:", error);
  }
};

  useEffect(() => {
    getCreatorMetrics();
  }, [creatorDate, subsidiary, division, startAmount, endAmount, budget, paper]);

  useEffect(() => {
    getWatcherMetrics();
  }, [creatorDate, subsidiary, division, startAmount, endAmount, , budget, paper]);

  useEffect(() => {
    getApproverMetrics();
  }, [creatorDate, subsidiary, division, startAmount, endAmount, , budget, paper]);

  useEffect(() => {
    getCompletedList();
  }, [recordsPerPage, pageStart]);

  const allCreatorGraph = [
    // {
    //   category: "Total",
    //   value: creatorMetric?.totalDocument,
    //   redirect: `/spa`,
    // },
    {
      category: "Created",
      value: creatorMetric?.created,
      redirect: `/spa?status=created`,
      subsidiaryFilter: subsidiary,
      divisionFilter: creatorDivision,
      dateFilter: creatorDate,
      amountFilter: creatorAmountData,
    },
    {
      category: "In Progress",
      value: creatorMetric?.inProgress,
      redirect: `/spa?status=In-Progress`,
      subsidiaryFilter: subsidiary,
      divisionFilter: creatorDivision,
      dateFilter: creatorDate,
      amountFilter: creatorAmountData,
    },
    {
      category: "Completed",
      value: creatorMetric?.completed,
      redirect: `/spa?status=completed`,
      subsidiaryFilter: subsidiary,
      divisionFilter: creatorDivision,
      dateFilter: creatorDate,
      amountFilter: creatorAmountData,
      turnOverTime: creatorMetric?.averageTurnOverTimeInMilliSec,
    },
    {
      category: "Cancelled",
      value: creatorMetric?.cancelled,
      redirect: `/spa?status=cancelled`,
      subsidiaryFilter: subsidiary,
      divisionFilter: creatorDivision,
      dateFilter: creatorDate,
      amountFilter: creatorAmountData,
    },
    {
      category: "Rejected",
      value: creatorMetric?.rejected,
      redirect: `/spa?status=rejected`,
      subsidiaryFilter: subsidiary,
      divisionFilter: creatorDivision,
      dateFilter: creatorDate,
      amountFilter: creatorAmountData,
    },
    {
      category: "Expired",
      value: creatorMetric?.expired,
      redirect: `/spa?status=expired`,
      subsidiaryFilter: subsidiary,
      divisionFilter: creatorDivision,
      dateFilter: creatorDate,
      amountFilter: creatorAmountData,
    },
  ];
  const allReviewerGraph = [
    {
      category: "Pending",
      value: approverMetric?.pendingDocument,
      redirect: `/spa-review?activeTab=pendingReview`,
      subsidiaryFilter: subsidiary,
      divisionFilter: approverDivision,
      dateFilter: approverDate,
      amountFilter: approverAmountData,
    },
    {
      category: "Approved",
      value: approverMetric?.approvedDocument,
      redirect: `/spa-review?activeTab=reviewed`,
      subsidiaryFilter: subsidiary,
      divisionFilter: approverDivision,
      dateFilter: approverDate,
      amountFilter: approverAmountData,
    },
    // {
    //   category: "Cancelled",
    //   value: approverMetric?.cancelled,
    //   redirect: `/spa?status=cancelled`,
    //   subsidiaryFilter: creatorSubsidiary,
    //   divisionFilter: creatorDivision,
    //   dateFilter: creatorDate,
    //   amountFilter: creatorAmountData,
    // },
  ];
  const watchersGraph = [
    {
      category: "Created",
      value: watcherMetric?.created,
      redirect: `/spa-watcher?watchers=true&status=created`,
      subsidiaryFilter: subsidiary,
      divisionFilter: watcherDivision,
      dateFilter: watcherDate,
      amountFilter: watcherAmountData,
    },
    {
      category: "In Progress",
      value: watcherMetric?.inProgress,
      redirect: `/spa-watcher?watchers=true&status=In-Progress`,
      subsidiaryFilter: subsidiary,
      divisionFilter: watcherDivision,
      dateFilter: watcherDate,
      amountFilter: watcherAmountData,
    },
    {
      category: "Completed",
      value: watcherMetric?.completed,
      redirect: `/spa-watcher?watchers=true&status=completed`,
      subsidiaryFilter: subsidiary,
      divisionFilter: watcherDivision,
      dateFilter: watcherDate,
      amountFilter: watcherAmountData,
      turnOverTime: watcherMetric?.averageTurnOverTimeInMilliSec,
    },
    {
      category: "Cancelled",
      value: watcherMetric?.cancelled,
      redirect: `/spa-watcher?watchers=true&status=cancelled`,
      subsidiaryFilter: subsidiary,
      divisionFilter: creatorDivision,
      dateFilter: creatorDate,
      amountFilter: creatorAmountData,
    },
    {
      category: "Rejected",
      value: watcherMetric?.rejected,
      redirect: `/spa-watcher?watchers=true&status=rejected`,
      subsidiaryFilter: subsidiary,
      divisionFilter: watcherDivision,
      dateFilter: watcherDate,
      amountFilter: watcherAmountData,
    },
    {
      category: "Expired",
      value: watcherMetric?.expired,
      redirect: `/spa-watcher?watchers=true&status=expired`,
      subsidiaryFilter: subsidiary,
      divisionFilter: watcherDivision,
      dateFilter: watcherDate,
      amountFilter: watcherAmountData,
    },
  ];

  return (
    <>
      <>
        <Row
          gutter={16}
          style={{ marginBottom: 20 }}
        >
          <Col span={24}>
            {isMobile ? (
              <WrapperCard
                isMobile={isMobile}
                title={"Overall View"}
                action={
                  <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <FilterDropDown
                      viewDivisions={true}
                      viewSubsidiary={false}
                      viewDate={true}
                      viewBudget={true}
                      viewPaper
                      setDate={setCreatorDate}
                      setBudget={setCreatorBudgetValue}
                      setPaper={setCreatorPaperValue}
                      setDivision={setCreatorDivision}
                      setSubsidiary={setCreatorSubsidiary}
                      isDashboard={true}
                      isMobile={isMobile}
                    />
                    <Button
                      type="primary"
                      onClick={() => navigate("/spa/add")}
                    >
                      Add New SPA
                    </Button>
                    <Button
                      icon={
                        <Icon
                          icon="bi:upload"
                          height={16}
                          style={{ marginRight: 10 }}
                        />
                      }
                      onClick={handleOverAllView}
                    >
                      Export
                    </Button>
                  </div>
                }
              >
                <div ref={overallChartRef}>
                  <PieChart
                    data={allCreatorGraph}
                    compactLegend={true}
                    isTotal={false}
                    showLegendCount={7}
                    tooltipTitle={`SPA`}
                    pieCenterContent={{
                      title: `Total`,
                      value: creatorMetric?.totalDocument,
                    }}
                    isMobile={isMobile}
                  />
                </div>
              </WrapperCard>
            ) : (
              <WrapperCard
                title={"Overall View"}
                action={
                  <div style={{ display: "flex", gap: 10, maxWidth: 900 }}>
                    <FilterDropDown
                      viewDivisions={true}
                      viewSubsidiary={false}
                      viewDate={true}
                      viewBudget={true}
                      viewPaper
                      setDate={setCreatorDate}
                      setBudget={setCreatorBudgetValue}
                      setPaper={setCreatorPaperValue}
                      setDivision={setCreatorDivision}
                      setSubsidiary={setCreatorSubsidiary}
                      // setAmountData={setCreatorAmountData}
                      isDashboard={true}
                    />
                    <Link to={`/spa/add`}>
                      <Tooltip
                        placement={"leftTop"}
                        title={`Add New SPA`}
                      >
                        <Icon
                          height={25}
                          icon={"mdi:file-document-plus"}
                        />
                      </Tooltip>
                    </Link>
                    <div onClick={handleOverAllView}>
                      <Tooltip
                        placement={"leftTop"}
                        title={`Export`}
                      >
                        <Icon
                          height={25}
                          icon={"bi:upload"}
                        />
                      </Tooltip>
                    </div>
                  </div>
                }
              >
                <div ref={overallChartRef}>
                  <PieChart
                    data={allCreatorGraph}
                    compactLegend={true}
                    isTotal={false}
                    showLegendCount={7}
                    tooltipTitle={`SPA`}
                    pieCenterContent={{
                      title: `Total`,
                      value: creatorMetric?.totalDocument,
                    }}
                  />
                </div>
              </WrapperCard>
            )}
          </Col>
        </Row>
        <Row
          gutter={16}
          style={{ marginBottom: 20 }}
        >
          <Col
            span={24}
            style={{ marginBottom: 20 }}
          >
            {isMobile ? (
              <WrapperCard
                isMobile={isMobile}
                title={"Watcher View"}
                action={
                  <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <FilterDropDown
                      viewDivisions={true}
                      viewSubsidiary={false}
                      viewDate={true}
                      viewBudget={true}
                      viewPaper
                      setDate={setWatcherDate}
                      setBudget={setWatcherBudgetValue}
                      setPaper={setWatcherPaperValue}
                      setDivision={setWatcherDivision}
                      setSubsidiary={setWatcherSubsidiary}
                      isMobile={isMobile}
                    />
                    <Button
                      icon={
                        <Icon
                          icon="bi:upload"
                          height={16}
                          style={{ marginRight: 10 }}
                        />
                      }
                      onClick={handleWatcherView}
                    >
                      Export
                    </Button>
                  </div>
                }
              >
                <div ref={watcherChartRef}>
                  <PieChart
                    data={watchersGraph}
                    compactLegend={true}
                    showLegendCount={7}
                    tooltipTitle={`SPA`}
                    pieCenterContent={{
                      title: `Total`,
                      value: watcherMetric?.totalDocument,
                    }}
                    isMobile={isMobile}
                  />
                </div>
              </WrapperCard>
            ) : (
              <WrapperCard
                title={"Watcher View"}
                action={
                  <div style={{ display: "flex", gap: 10, maxWidth: 900 }}>
                    <FilterDropDown
                      viewDivisions={true}
                      viewSubsidiary={false}
                      viewDate={true}
                      viewBudget={true}
                      viewPaper
                      setDate={setWatcherDate}
                      setBudget={setWatcherBudgetValue}
                      setPaper={setWatcherPaperValue}
                      setDivision={setWatcherDivision}
                      setSubsidiary={setWatcherSubsidiary}
                    />
                    <div onClick={handleWatcherView}>
                      <Tooltip
                        placement={"leftTop"}
                        title={`Export`}
                      >
                        <Icon
                          height={25}
                          icon={"bi:upload"}
                        />
                      </Tooltip>
                    </div>
                  </div>
                }
              >
                <div ref={watcherChartRef}>
                  <PieChart
                    data={watchersGraph}
                    compactLegend={true}
                    showLegendCount={7}
                    tooltipTitle={`SPA`}
                    pieCenterContent={{
                      title: `Total`,
                      value: watcherMetric?.totalDocument,
                    }}
                  />
                </div>
              </WrapperCard>
            )}
          </Col>
        </Row>
        {hasRole(["SPA_ADMIN", "SPA_APPROVER"]) && (
          <Row
            gutter={16}
            style={{ marginBottom: 20 }}
          >
            <Col span={24}>
              {isMobile ? (
                <WrapperCard
                  isMobile={isMobile}
                  title={"Approver View"}
                  action={
                    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                      <FilterDropDown
                        viewDivisions={true}
                        viewSubsidiary={false}
                        viewDate={true}
                        viewBudget={true}
                        viewPaper
                        setDate={setApproverDate}
                        setDivision={setApproverDivision}
                        setBudget={setApproverBudgetValue}
                        setPaper={setApproverPaperValue}
                        setSubsidiary={setApproverSubsidiary}
                        isMobile={isMobile}
                      />
                      <Button
                      icon={
                        <Icon
                          icon="bi:upload"
                          height={16}
                          style={{ marginRight: 10 }}
                        />
                      }
                      onClick={handleApproverView}
                    >
                      Export
                    </Button>
                    </div>
                  }
                >
                  <div ref={approverChartRef}>
                    <PieChart
                      data={allReviewerGraph}
                      compactLegend={true}
                      showLegendCount={7}
                      tooltipTitle={`SPA`}
                      pieCenterContent={{
                        title: `Total`,
                        value: approverMetric?.totalDocument,
                      }}
                      isMobile={isMobile}
                    />
                  </div>
                </WrapperCard>
              ) : (
                <WrapperCard
                  title={"Approver View"}
                  action={
                    <div style={{ display: "flex", gap: 10, maxWidth: 900 }}>
                      <FilterDropDown
                        viewDivisions={true}
                        viewSubsidiary={false}
                        viewDate={true}
                        viewBudget={true}
                        viewPaper
                        setDate={setApproverDate}
                        setDivision={setApproverDivision}
                        setBudget={setApproverBudgetValue}
                        setPaper={setApproverPaperValue}
                        setSubsidiary={setApproverSubsidiary}
                        // setAmountData={setApproverAmountData}
                      />
                      {/* <Link to={`/approver/add?authority=gcfo/gcoo`}>
                      <Tooltip
                        placement={"leftTop"}
                        title={`Add New Approver`}
                      >
                        <Icon
                          height={25}
                          icon={"mdi:file-document-plus"}
                        />
                      </Tooltip>
                    </Link> */}
                      <div onClick={handleApproverView}>
                        <Tooltip
                          placement={"leftTop"}
                          title={`Export`}
                        >
                          <Icon
                            height={25}
                            icon={"bi:upload"}
                          />
                        </Tooltip>
                      </div>
                    </div>
                  }
                >
                  <div ref={approverChartRef}>
                    <PieChart
                      data={allReviewerGraph}
                      compactLegend={true}
                      showLegendCount={7}
                      tooltipTitle={`SPA`}
                      pieCenterContent={{
                        title: `Total`,
                        value: approverMetric?.totalDocument,
                      }}
                    />
                  </div>
                </WrapperCard>
              )}
            </Col>
          </Row>
        )}
        <Row gutter={16}>
          <Col
            xs={24}
            lg={24}
          >
            <Row>
              <Col
                span={24}
                style={colCommonStyles}
              >
                <LatestContracts
                  isMobile={isMobile}
                  moduleName={`Latest Onboarded List`}
                  data={onBoardingList}
                  isLoading={isLoading}
                  url={`/spa`}
                  totalPage={totalPage}
                  onPageChange={handlePageChange}
                  currentPage={page}
                  pageSize={recordsPerPage}
                />
              </Col>
            </Row>
          </Col>
        </Row>
      </>
    </>
  );
};
